import { Component } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { FormControl } from '@angular/forms';
import { Password } from '@models/account/password.model';

@Component({
    selector: 'app-form-password',
    templateUrl: './password.template.html',
    styleUrls: ['./password.style.scss'],
})
export class PasswordForm extends BaseForm {
    readonly passwordMinimumLength = 8;
    hasUpperCase = false;
    hasLowerCase = false;
    hasNumber = false;
    hasMinimumCharacters = false;
    passwordsMatch = false;

    password: FormControl<string> = new FormControl();
    confirmPassword: FormControl<string> = new FormControl();

    reset(): void {
        this.password = new FormControl();
        this.confirmPassword = new FormControl();
        this.validatePasswords();
    }

    validatePasswords(): void {
        if (this.password.value) {
            this.hasUpperCase = !!this.password.value.match(/[A-Z]/);
            this.hasLowerCase = !!this.password.value.match(/[a-z]/);
            this.hasNumber = !!this.password.value.match(/\d/);
            this.hasMinimumCharacters = this.password.value.length >= this.passwordMinimumLength;
        } else {
            this.hasUpperCase = false;
            this.hasLowerCase = false;
            this.hasNumber = false;
            this.hasMinimumCharacters = false;
        }

        if (this.password.value && this.confirmPassword.value) {
            this.passwordsMatch = this.password.value === this.confirmPassword.value;
        }
    }

    getPasswordModel(): Password {
        const newPass = new Password();

        if (this.hasValidPassword()) {
            newPass.value = this.password.value;
        }

        return newPass;
    }

    hasValidPassword(): boolean {
        return (
            this.hasLowerCase && this.hasUpperCase && this.hasNumber && this.hasMinimumCharacters && this.passwordsMatch
        );
    }
}
